<template>
    <div>
        <div class="card" v-if="sesion">
            <div class="card-header">
                <div class="text-center text-lg-left">
                    <div class="d-md-flex justify-content-md-between">
                        <h3 class="card-title my-3">Cupones para la sesión: {{ sesion.fecha }}</h3>
                        <div>
                            <Button id="nuevo-cupon" class="m-1" @click="showModal('CreateVoucher')">Nuevo cupón</Button>
                            <CreateVoucher :session_id="session_id" :event_id="event_id" v-on:close="closeModal"></CreateVoucher>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <div class="table-responsive has-options">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Código</th>
                                        <th>Descuento (%)</th>
                                        <th>Descuento (fijo)</th>
                                        <th>Usos</th>
                                        <th class="text-center">Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(voucher, index) in voucher_codes">
                                        <tr :key="index">
                                            <td>{{ voucher.name }}</td>
                                            <td>{{ voucher.code }}</td>
                                            <td>{{ voucher.discount_percent }}</td>
                                            <td>{{ voucher.discount_fixed }}</td>
                                            <td>{{ voucher.units }}</td>
                                            <td class="text-center">
                                                <OpcionesDropdownComponent v-bind:options="[
                                                    { type: 'action', action:() => showModal('UpdateVoucher-' + voucher.id), label: 'Editar'},
                                                    { type: 'action', action:() => showModal('DeleteVoucher-' + voucher.id), label: 'Borrar'},
                                                ]"/>
                                            </td>
                                            <EditarModal :event_id="event_id" :session_id="session_id" :voucher="voucher" v-on:close="closeModal"></EditarModal>
                                            <BorrarModal :event_id="event_id" :session_id="session_id" :voucher="voucher" v-on:close="closeModal"></BorrarModal>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import CreateVoucher from './../../modals/CreateVoucher';
import EditarModal from './../../modals/UpdateVoucher';
import BorrarModal from './../../modals/DeleteVoucher';
import OpcionesDropdownComponent from '@/components/backend/components/OpcionesDropdownComponent';

export default {
    props: ['event_id', 'session_id'],
    data() {
        return {
            sesion: null,
            voucher_codes: [],
            loading: false,
        }
    },
    created() {
        this.getSesion();
        this.getVouchers();
    },
    methods: {
        getVouchers() {
            this.loading = true;

            const params = {
                filters : {},
                event_id: this.event_id,
                session_id: this.session_id
            };
                
            this.$store.dispatch(this.config.getVuexAlias('back.events.voucher.index'), params).then(res => {
                this.voucher_codes = res.data.data;
            }).finally(() => this.loading = false);
        },
        getSesion() {
            this.loading = true;

            const params = {
                filters : {},
                evento_id: this.event_id,
                sesion_id: this.session_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.show'), params).then(res => {
                this.sesion = res.data.data;
                this.entradas = res.data.data.entradas;
            }).finally(() => this.loading = false);
        },
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal, editado) {
            if(editado) this.getVouchers();
            this.$modal.hide(modal);
        },
    },
    components: {
        CreateVoucher, EditarModal, BorrarModal, OpcionesDropdownComponent
    }
}
</script>
